module.exports = __webpack_public_path__ + "img/time-activity-reports.a00310c8.webp";